import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"


const initialState = {
    data: null,
    response: null,
    loading: false,
    error: null,
    goalList: null,
    singlehrHandBook: null,
}

export const GetGoalList = createAsyncThunk(
    "GetGoalList",
    async (body) => {
        try {

            const response = await instance.get(`/crm/goals/fetch-goal-list?page=1&search=`)
            //  debugger
            // const response = await instance.get(`/crm/goals/fetch-goal-list?page=${body.page}&search=${body.search}`)
            return response.data;
        } catch (error) {
            throw error;
        }
    }
)

export const CreateGoal = createAsyncThunk(
    "CreateGoal",
    async (body) => {


        try {
            const response = await instance.post("/crm/goals/add-goal", body);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
)

export const UpdateGoal = createAsyncThunk(
    "UpdateGoal",
    async (body) => {
        // debugger
        // const formData = new FormData();
        // formData.append("h_title", body.h_title);
        // formData.append("h_description", body.h_description);
        // formData.append("h_handbookpdf_doc", body.handbookpdf_doc[0]);





        try {
            const response = await instance.post(`/crm/goals/edit-goal?id=${body?.id}`, body);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
)



export const removeGoal = createAsyncThunk(
    "removeGoal",
    async (id) => {
        try {
            const response = await instance.post(`/crm/goals/delete-goal?id=${id}`);
            return response.data
        } catch (error) {

        }
    }
)

//update status----end
export const Updatestatus = createAsyncThunk(
    "Updatestatus",
    async (data) => {
        try {
            // debugger;
            const response = await instance.post(`/crm/hrHandBooks/update-hrHandBook-status?ex_id=${data?.ex_id}`, { "ex_action": data?.ex_action })
            return response.data
        } catch (error) {
            throw error;
        }
    }
)

export const GoalSlice = createSlice({
    name: "GoalSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        //GET GOAL LIST
        builder.addCase(GetGoalList.pending, (state) => {
            state.loading = true;
            state.data = null;
        });
        builder.addCase(GetGoalList.fulfilled, (state, action) => {
            //  debugger
            state.loading = false;
            state.goalList = action.payload;

        });
        builder.addCase(GetGoalList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });

        //CREATE GOAL
        builder.addCase(CreateGoal.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(CreateGoal.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(CreateGoal.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });

        //UPDATE GOAL
        builder.addCase(UpdateGoal.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(UpdateGoal.fulfilled, (state, action) => {
            state.loading = false;
            state.showPolicy = action.payload;
        });
        builder.addCase(UpdateGoal.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });

        //REMOVE GOAL
        builder.addCase(removeGoal.pending, (state) => {
            state.loading = true;
            state.data = null
        })
        builder.addCase(removeGoal.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(removeGoal.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });

    }
})

export default GoalSlice.reducer;